import { render, staticRenderFns } from "./cmsContentList.vue?vue&type=template&id=20db966a&scoped=true"
import script from "./cmsContentList.vue?vue&type=script&lang=ts"
export * from "./cmsContentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db966a",
  null
  
)

export default component.exports